<script lang="ts">
  import type { CartProduct } from "@shared/types/ProductLine";
  import { stagedRolloutCheck } from "@shared/svelte/Modules/StagedRolloutCheck.svelte";

  export let product: any;
  export let showWhenProductHasErrors: boolean = true;
  export let distributor: {
    id?: number;
    associated?: boolean;
    require_account_number_for_add_to_cart?: boolean;
    sf_requires_a_price_to_order_a_product?: boolean;
    uses_wine_cellar?: boolean;
    out_of_stock?: { [key: string]: boolean };
  };
  export let location: string = "";

  function showSection(product: CartProduct) {
    if (!product) {
      return false;
    }

    if (showWhenProductHasErrors) {
      if (window["$rootScope"]?.user?.role === "sales_rep") {
        return false;
      }
      return productHasErrors(product);
    } else {
      if (window["$rootScope"]?.user?.role === "sales_rep") {
        return true;
      }
      return !productHasErrors(product);
    }
  }

  function productHasErrors(product: any) {
    let hasNoErrors = inStock(product) && isAvailable(product);
    if (product.inventory_id) {
      hasNoErrors = hasNoErrors && isOrderable(product);
    }
    return !hasNoErrors;
  }

  const canUseWineCellar =
    stagedRolloutCheck("marketplace__fulfillment_methods") && distributor?.uses_wine_cellar;
  const inStock = (product: any) => {
    const isOutOfStock = canUseWineCellar
      ? distributor.out_of_stock?.[product.product_id]
      : product.inventory_below_minimum;
    return (product.allocation && product.allocation.is_allocated) || !isOutOfStock;
  };
  function inventoryDeleted() {
    return !!distributor.id && !product.inventory_id;
  }

  const isLimitedAllocation = (product: any) =>
    product.allocation?.is_allocated && product.allocation?.amount == 0;

  const isAvailable = (product: any) => {
    if (!showUnavailableError(location)) {
      return true;
    }
    return (
      !(product.is_available == false) &&
      !isHidden(product) &&
      distributor.associated != false &&
      !inventoryDeleted()
    );
  };

  function isHidden(product: any) {
    return product.inventory && product.inventory.hidden;
  }

  function needsAPriceButLacksOne() {
    return (
      distributor.sf_requires_a_price_to_order_a_product &&
      product.case_price === null &&
      product.unit_price === null
    );
  }

  const showUnavailableError = (location: any) =>
    ["cart", "list-detail", "listv2-detail"].includes(location);

  const isOrderable = (product: any) => {
    if (isLimitedAllocation(product)) {
      return false;
    } else if (distributor.require_account_number_for_add_to_cart) {
      return false;
    } else if (needsAPriceButLacksOne()) {
      return false;
    } else if (product.orderable !== undefined) {
      return product.orderable;
    } else {
      return true;
    }
  };
</script>

{#if showSection(product)}
  <slot />
{/if}
